import React from 'react';
import { Box, makeStyles, Typography, useTheme } from '@material-ui/core';
import { Link, useLocation } from 'react-router-dom';
import ChevronRightIcon from '@material-ui/icons/ChevronRight';
import {
  APPROVAL_DISCOVERY_APP_ROUTE,
  APPROVAL_MGMENT_APP_ROUTE,
  FINANCE_MODULE_ROUTE,
  APPROVAL_JFT_ROUTE,
  APPROVAL_USER_KYC_ROUTE,
  APPROVAL_STORY_ROUTE,
} from '../../routes/routes';
import { useDispatch, useSelector } from 'react-redux';
import {
  emptyCommonApprovalState,
  emptyCommonOneApproval,
  emptyUserDetails,
} from './ApprovalStore/approvalSlice';
import useScopes from '../../hooks/useScopes';
const linkStyle = {
  height: 64,
  paddingLeft: 16,
  paddingRight: 16,
  marginTop: 8,
  marginBottom: 8,
  borderRadius: 4,
};

const useStyles = makeStyles((theme) => ({
  overAll: { height: '100%', paddingLeft: 5, paddingRight: 5 }, // 438
  linkStyle: {
    ...linkStyle,
  },
  linkStyleActive: {
    ...linkStyle,
    backgroundColor: theme.palette.buzzActiveLinkBackground,
  },
  textStyle: {
    textDecoration: 'none',
  },
}));

const isActiveRoute = (routeName, pathName) => {
  if (
    pathName === FINANCE_MODULE_ROUTE.slice(0, -1) &&
    routeName === APPROVAL_MGMENT_APP_ROUTE
  )
    return true;
  else if (pathName !== FINANCE_MODULE_ROUTE.slice(0, -1)) {
    return pathName.includes(routeName);
  }
};

const SideNavBar = () => {
  const classes = useStyles();
  const { pathname } = useLocation();
  const theme = useTheme();
  const dispatch = useDispatch();
  const { access } = useScopes();

  const { moduleAccess } = useSelector(({ signInReducer }) => {
    return {
      moduleAccess: signInReducer.me
        ? signInReducer.me.data
          ? signInReducer.me.data.role
          : []
        : [],
    };
  });

  const paths = [
    {
      name: 'Management App',
      link: APPROVAL_MGMENT_APP_ROUTE,
      scope: 'approval:management:readWrite',
    },
    {
      name: 'Discovery App',
      link: APPROVAL_DISCOVERY_APP_ROUTE,
      scope: 'approval:discovery:readWrite',
    },
    {
      name: 'JFT',
      link: APPROVAL_JFT_ROUTE,
      scope: '',
    },
    {
      name: 'KYC Approval',
      link: APPROVAL_USER_KYC_ROUTE,
      scope: 'approval:management:readWrite',
    },
    {
      name: 'Story Approval',
      link: APPROVAL_STORY_ROUTE,
      scope: 'approval:management:readWrite',
    },
  ];

  const handleResetState = () => {
    dispatch(emptyCommonApprovalState());
    dispatch(emptyCommonOneApproval());
    dispatch(emptyUserDetails());
  };

  return (
    <Box
      flex={2}
      mr={3}
      border={1}
      borderColor={theme.palette.buzzBorder}
      borderRadius={4}
      className={classes.overAll}>
      {paths.map((path) => {
        const isActive = isActiveRoute(path.link, pathname);
        return moduleAccess.includes('bccSuperAdmin') ||
          access({
            mode: 'allOf',
            scope: [path.scope],
          }) ? (
          <>
            <Link
              onClick={handleResetState}
              key={path.name}
              to={path.link}
              color="inherit"
              className={classes.textStyle}>
              <Box
                className={
                  isActive ? classes.linkStyleActive : classes.linkStyle
                }
                display="flex"
                alignItems="center">
                <Box flexGrow={1}>
                  <Typography color="textPrimary" component="div">
                    <Box fontWeight={isActive ? 'fontWeightMedium' : ''}>
                      {path.name}
                    </Box>
                  </Typography>
                </Box>
                {isActive && <ChevronRightIcon color="primary" />}
              </Box>
            </Link>
          </>
        ) : null;
      })}
    </Box>
  );
};

export default SideNavBar;
